export const PATH_W =
  "M346 -2Q336 -2 334 1L83 542Q64 584 47.5 598.5Q31 613 1 613Q-2 613 -2.0 619.0Q-2 625 1 625L32 624Q58 622 81 622Q126 622 170 624Q184 625 208 625Q211 625 211.0 619.0Q211 613 208 613Q179 613 166.0 607.0Q153 601 153 584Q153 570 167 539L370 105L451 311L344 542Q327 579 309.5 596.0Q292 613 267 613Q264 613 264.0 619.0Q264 625 267 625L298 624Q322 622 342 622Q380 622 412 624Q422 625 439 625Q442 625 442.0 619.0Q442 613 439 613Q422 613 414.5 610.0Q407 607 407 598Q407 584 428 539L492 402L541 527Q555 564 555 582Q555 598 546.0 605.5Q537 613 518 613Q516 613 516.0 619.0Q516 625 518 625L538 624Q558 622 584 622Q602 622 628 624L668 625Q670 625 670.0 619.0Q670 613 668 613Q634 613 609.0 592.0Q584 571 565 522L506 373L631 105L795 522Q804 546 804 563Q804 613 735 613Q732 613 732.0 619.0Q732 625 735 625L778 624Q812 622 840 622Q861 622 887 624L929 625Q932 625 932.0 619.0Q932 613 929 613Q857 613 821 522L617 1Q616 -2 607 -2Q597 -2 595 1L465 281L356 1Q355 -2 346 -2Z";
export const PATH_J =
  "M285 613Q255 613 240.5 607.0Q226 601 221.0 586.5Q216 572 216 542V-20Q216 -124 167.5 -183.5Q119 -243 28 -243Q-7 -243 -28.0 -230.0Q-49 -217 -49 -195Q-49 -178 -39.0 -167.0Q-29 -156 -10 -156Q10 -156 20.5 -165.5Q31 -175 41 -194Q50 -210 56.5 -216.5Q63 -223 74 -223Q105 -223 120.5 -184.0Q136 -145 136 -57V544Q136 574 129.0 588.0Q122 602 102.5 607.5Q83 613 42 613Q40 613 40.0 619.0Q40 625 42 625L101 624Q147 622 175 622Q201 622 241 624L285 625Q288 625 288.0 619.0Q288 613 285 613Z";
export const PATH_DOT =
  "M52 38Q52 59 65.5 71.5Q79 84 101 84Q124 84 136.5 71.5Q149 59 149 38Q149 15 136.5 2.0Q124 -11 101 -11Q79 -11 65.5 2.5Q52 16 52 38Z";

export const Logo = ({ width = 96, animated = false, className = "" }) => (
  <svg
    viewBox="0 0 1381 940"
    width={width}
    role="img"
    aria-label="Wim Jansen Delgado"
    data-testid="wj-logo"
    className={`block ${className}`}
  >
    <g transform="translate(38 661) scale(1 -1)">
      <g fill="currentColor">
        <path d={PATH_W} />
        <path d={PATH_J} transform="translate(891 0)" />
      </g>
      <g fill="#D94E28" className={animated ? "logo-dot" : undefined}>
        <path d={PATH_DOT} transform="translate(1158 0)" />
      </g>
    </g>
  </svg>
);
